import { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import courseEnrollmentService from '../../services/api/course-enrollment'
import useCurrentUser from '../use-current-user'
import { get } from 'lodash'
import useCacheKeys from '../use-cache-keys'
import useCache from '../use-cache'

const useCourseEnrollment = ({
    userId,
    courseId,
    onSuccess = () => {},
    onError = () => {},
}) => {

    const { id } = useCurrentUser()
    const cacheKeys = useCacheKeys()
    const { clearCache } = useCache({ key: cacheKeys.COURSES, onReload: onSuccess })

    const [ enrollCourse, { isLoading: isEnrolling } ] = useMutation(() => courseEnrollmentService.enroll({ userId, courseId }), {
        onSuccess: clearCache,
        onError
    })

    const [ unenrollCourse, { isLoading: isUnenrolling} ] = useMutation(() => courseEnrollmentService.drop({ userId, courseId }), {
        onSuccess: clearCache,
        onError,
    })

    return {
        isBusy: isEnrolling || isUnenrolling,
        enrollCourse,
        unenrollCourse,
    }
}

export default useCourseEnrollment